const Page404 = () => {
  return (
    <div className="flex flex-col items-center justify-between gap-6 rounded-lg bg-navy-blue p-8 text-white">
      <span className="text-8xl">404</span>
      <span className="text-xl">
        You didn't break the internet, but we can't find what you are looking for.
      </span>
    </div>
  )
}

export default Page404
